import { IOrganizationSearch } from '@/client/legacy-shared-modules/search/search-types';

import type { SearchAIResults_OrganizationsByIds_sponsorsByIds_results } from '../../graphql-types/SearchAIResults_OrganizationsByIds';
import {
  draftJsContentToPlainText,
  orderRecordsByIds,
} from '../../utils/contentHelpers';

export function mapOrganizationsByIdsToOrganizationHits(
  organizations: SearchAIResults_OrganizationsByIds_sponsorsByIds_results[],
  orderedOrganizationIds: string[]
): IOrganizationSearch[] {
  return orderRecordsByIds(organizations, orderedOrganizationIds).map(
    (organization) => {
      const aboutUsPlainText = draftJsContentToPlainText(organization.aboutUs);
      const dateCreated = organization.dateCreated
        ? new Date(organization.dateCreated)
        : new Date(0);

      return {
        scope: [],
        objectID: organization._id,
        name:
          organization.name?.trim() ||
          organization.displayName?.trim() ||
          'Organization',
        aboutUs: aboutUsPlainText,
        dateCreated,
        profilePictureUrl: organization.profilePicture?.imageProxy ?? null,
        sponsorTier: {
          name: organization.sponsorship?.currentTier?.name ?? '',
          order: 0,
        },
      };
    }
  );
}
